export const businessTransactionsStoreKey = 'businessTransactions';
